module.exports = "<ul class=\"accountLeftBar\">\r\n<li><a [routerLinkActive]=\"['activeAccount']\" [routerLink]=\"['/users/userdetail']\">Details</a></li>\r\n<li><a [routerLinkActive]=\"['activeAccount']\" [routerLink]=\"['/users/updatepassword']\">Security</a></li>\r\n<li><a [routerLinkActive]=\"['activeAccount']\" [routerLink]=\"['/users/deleteaccount']\">Delete Account</a></li>\r\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/usersidemenu.component.html
// module id = 1079
// module chunks = 31